import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcProperty(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.25 8.469h-1a.75.75 0 0 1 0-1.5h1a.75.75 0 0 1 0 1.5M7.25 12.611h1a.75.75 0 0 0 0-1.5h-1a.75.75 0 0 0 0 1.5M8.25 16.754h-1a.75.75 0 0 1 0-1.5h1a.75.75 0 0 1 0 1.5M12.75 8.469h-1a.75.75 0 0 1 0-1.5h1a.75.75 0 0 1 0 1.5M15.5 16.753h1a.75.75 0 0 0 0-1.5h-1a.75.75 0 0 0 0 1.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.75 5A2.25 2.25 0 0 1 5 2.75h10A2.25 2.25 0 0 1 17.25 5v5.75H19A2.25 2.25 0 0 1 21.25 13v6A2.25 2.25 0 0 1 19 21.25H5A2.25 2.25 0 0 1 2.75 19zm13 0v5.75H13A2.25 2.25 0 0 0 10.75 13v6.75H5a.75.75 0 0 1-.75-.75V5A.75.75 0 0 1 5 4.25h10a.75.75 0 0 1 .75.75m-3.5 14.75V13a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-.75.75z",
    clipRule: "evenodd"
  }));
}
var IcProperty = createNolIcon(/*#__PURE__*/forwardRef(SvgIcProperty));

export { IcProperty as I };
